import CircleBtn from "./Circlebtn";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import "../../assets/fonts/fonts.css";
import { SocialIcons } from "./Icons";
import { useTheme } from "../../context/ThemeContext";
import ArrowBlk from "../../assets/images/ArrowBlk.png";
import ArrowLgt from "../../assets/images/ArrowLgt.png";
import Parallax from "./Parallax";
import { Row } from "./Containers";

const MegaDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 1110px) {
    justify-content: end;
    align-items: flex-end;
    flex-direction: column;
  }
`;

const BoldTxt = styled.div`
  text-align: end;
  font-size: 30px;
  font-weight: 900;
  margin-right: 5rem;
  .tiny {
    font-weight: 100;
    font-size: 18px;
  }
  @media (max-width: 1110px) {
    margin-right: 0rem;
  }

    @media (max-width: 576px) {
    font-size: 25px;
  }
`;

const LineAndSocial = styled.div`
  display: flex;
  // background: red;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 5rem;
  .hr {
    width: 40vw;
    color: ${({ theme }) => theme.text};
  }
  @media (max-width: 1110px) {
    margin-left: 0rem;
    justify-content: end;
    align-items: end;
     .hr {
    width: 80vw;
    }
  }
`;

const ArrowAndBtn = styled.div`
  display: flex;
  justify-content: end;
  // border: 1px solid black;
  // margin-top: -0.8rem;
  // margin-right: 6rem;
  img {
    margin-left: -1.5rem;
  }
`;

const ControlDiv = styled.div`
  @media (min-width: 1373px) {
  // border: 1px solid black;
  width: 90%;
  margin: 0 auto;
  }

`;

export default function ContactInfo() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <Row>
      <div className="texContainer">
        <p className="josefin-slab">hola</p>
        <p className="jacques-francois-shadow">hello</p>
        <p className="finger-paint">bonjour</p>
        <p className="nato-sans-jp">こんにちは </p>
      </div>

  <ControlDiv> 
  <MegaDiv>
        <BoldTxt>
          Your Project,
          <br />
          Our Passion—Let's Begin!
          <p className="tiny">Or just say Hello</p>
        </BoldTxt>

        <LineAndSocial>
          <SocialIcons isDarkMode={theme === "dark"} />
          <hr className="hr" />
        </LineAndSocial>
      </MegaDiv>

      <ArrowAndBtn>
        <div>
          <img
            src={theme === "dark" ? ArrowLgt : ArrowBlk}
            alt="Arrow"
            width={"24px"}
          />
          <Parallax offset={30} borderRadius="50%">
          <CircleBtn
            $text={"Get in\n touch"}
            onClick={handleClick}
            $size="140px"
            $magneticBorderRadius="50%"
          />
          </Parallax>
        </div>
      </ArrowAndBtn>
     
  </ControlDiv>
    </Row>
  );
}
